module.exports = __webpack_public_path__ + "static/media/top_shape_4.904b7d80.svg";